module.exports = __webpack_public_path__ + "static/media/emptytxn.09c264d1.svg";